<template>
    <div class="modal fade" id="mediaPermissionModal" tabindex="-1" aria-labelledby="mediaPermissionModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">Aviso</h1>
                </div>
                <div class="modal-body">
                    <ul class="m-0" v-if="!browser_has_camera_permission">
                        <li>
                            Você precisa permitir a utilização da câmera para realizar as biometrias obrigatórias!
                        </li>
                        <li>
                            Após permitir o acesso à câmera, atualize a página.
                        </li>
                    </ul>

                    <ul class="m-0" v-else>
                        <li>Não foi possível acessar sua câmera.</li>
                        <li>
                            É necessário que você autorize a utilização da câmera
                        </li>
                        <li>
                            Caso o erro persista, entre em contato com o suporte.
                        </li>
                        <li>
                            {{ browser_permission_unknown_error.error_message }}
                        </li>
                    </ul>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Entendi</button>
                </div>
            </div>
        </div>
    </div>

	<div style="display: none" id="random-cam">random-cam</div>

	<meeting_alerts
		:ban="props.ban"
		:date_protocol="props.date_protocol"
		:starting_class="starting_class"
		:class_finished="props.class_finished"
		:class_ready="props.records.class_status === 'READY'"
		:class_canceled="props.records.class_status === 'CANCELED'"
		:class_closed_with_pending="props.records.class_status === 'PENDING'"
		:time_is_over_class="time_is_over_class"
		:student_registered_in_class="props.student_registered_in_class"
		:haveMeet="props.haveMeet"
		:student_name="props.records.name"
		:student_cpf="props.records.cpf"
		:user_registrant_id="props.user_registrant.id"
		:student_in_class="student_in_class"
		:failed_to_open_class="failed_to_open_class"
		:class_start_at="props.class_start_at_formated"
		:additional_minutes_to_open_class="
			props.additional_minutes_to_open_class
		"
		:additional_minutes_to_close_class="
			props.additional_minutes_to_close_class
		"
		:closed_before_students_waiting_time="
			props.records.closed_before_students_waiting_time
		"
		:user_registrant="props.user_registrant"
		:class_deadline_formated="props.class_deadline_formated"
	/>

	<div
		v-if="
			props.records.class_status === 'STARTED' &&
			props.haveMeet &&
			!time_is_over_class &&
			!props.ban
		">
		<meeting_iframe
			@attachments_button_clicked="() => show_attachments = true"
			@successfully_loaded="api => jitsi_api = api"
			:key="meeting_iframe_key"
			:jitsi_domain="props.jitsi_domain"
			:token_jwt="props.token_jwt"
			:room_name="props.room_name"
			:toolbar_buttons="['microphone', 'camera', 'chat', 'hangup', 'fullscreen', 'whiteboard', 'etherpad', 'raisehand']"
		/>
	</div>

	<user_cam_modal
		:key="user_cam_modal_key"
		ref="user_cam_component"
		@partialReload="partialReload()"
		:text_cam="text_cam"
		:urlRoute="urlRoute"
		:mock_user_photo_b64="props.mock_user_photo_b64"
		:additional_time="times.class_deadline_with_additional_time"
		:close_class="close_class"
		:get_class_data="{api_token: props.api_token, url: props.get_class_data_url}"
		:api_token="props.api_token"
		:browser_has_all_media_permissions="browser_has_camera_permission && !browser_permission_unknown_error.active"
		:biometry_tries="student_biometry_tries"
		:biometry_tries_limit="props.biometry_tries.allowed_biometry_tries"
		@biometry_executed="student_biometry_tries += 1"
		@biometry_successful="handleSuccessfulBiometry"
	/>

    <class_paused_modal :class_paused="class_paused" />

	<attachments_modal
        :url="props.attachment_url" 
        @close="show_attachments = false"
        :show="show_attachments"/>  
</template>

<script setup lang="ts">
	import { computed, onBeforeMount, onMounted, onUnmounted, PropType, reactive, Ref, ref, watch } from 'vue';
	import { router, usePage } from '@inertiajs/vue3';
	import { WebSocketStudentBuilder } from '../../websockets/WebsocketStudent';
	import { UserRegistrantConst } from '../../Interfaces/UserRegistrantConst';
	import { TimesStudentClass } from '../../Interfaces/TimesStudentClass';
	import { getTimerWithDistanceMinutesSeconds } from '../../utils/timer';
	import user_cam_modal from '../../components/Student/user_cam_modal.vue';
	import meeting_iframe from '../../components/Class/meeting_iframe.vue';
	import meeting_alerts from '../../components/Student/meeting_alerts.vue';
	import { menuStore } from '../../stores/menu';
	import Swal from 'sweetalert2';
	import { SnapPhotoAndSendRequestSavePhoto } from '../../utils/requestModalWebcam';
	import axios from 'axios';
	import class_paused_modal from '../../components/Class/class_paused_modal.vue'
	import BrowserMediaPermissionManager from '../../utils/BrowserMediaPermissionManager';
	import { BiometryTries } from '../../Interfaces/BiometryTries';
	import { ClassBan } from '../../Interfaces/ClassBan';
	import { UserRegistrant } from 'resources/js/Interfaces/UserRegistrant';
    import attachments_modal from '../../components/Class/attachments_modal.vue';

	const props = defineProps({
		records: { type: Object, required: true },
		haveMeet: { type: Boolean, required: true },
		student_registered_in_class: { type: Boolean, required: true },
		class_finished: { type: Boolean, required: true },
		ws_scheme: { type: String, required: true },
		ws_base_url: { type: String, required: true },
		mock_user_photo_b64: { type: String, required: true },
		random_photo_url: { type: String, required: true },
		class_deadline: { type: String, required: true },
		class_deadline_with_additional_time: { type: String, required: true },
		time_middle_class_biometric_validation: {
			type: String,
			required: true,
		},
		registered_const_value: { type: String, required: true },
		initial_biometry_const_value: { type: String, required: true },
		random_biometry_const_value: { type: String, required: true },
		finished_const_value: { type: String, required: true },
		failed_to_open_class_const_value: { type: String, required: true },
		store_student_photo_urls: { type: Object, required: true },
		classroom_index_url: { type: String, required: true },
		room_name: { type: String, required: true },
		token_jwt: { type: String, required: true },
		time_to_random_biometric: { required: true },
		milliseconds_between_random_biometrics: {
			type: Number,
			required: true,
		},
		miliseconds_to_check_student_activity: { type: Number, required: true },
		student_last_seen_route: { type: String, required: true },
		student_last_seen: { type: String, required: true },
		api_token: { type: String, required: true },
		student_in_class_consts: { type: Array, required: true },
		now: { type: String, required: true },
		invalid_statuses_for_student_operations: {
			type: Array,
			required: true,
		},
		student_time_limit_to_open_class: { type: String, required: true },
		class_start_at_formated: { type: String, required: true },
		additional_minutes_to_open_class: { type: Number, required: true },
		additional_minutes_to_close_class: { type: Number, required: true },
		date_protocol: { type: String, required: true },
		get_class_data_url: {type: String, required: true},
		get_time_url: {type: String, required: true},
		get_ban_status_url: {type: String, required: true},
		jitsi_domain: {type: String, required: false},
		class_paused: {type: Boolean, required: true},
		biometry_tries: {type: Object as PropType<BiometryTries>, required: true},
		ban: {type: Object as PropType<ClassBan>, required: false},
		user_registrant: {type: Object as PropType<UserRegistrant>, required: true},
		class_deadline_formated: { type: String, required: true },
        has_pending_items: {type: Boolean, required: true},
		attachment_url: {type: String, required: true},
	});

    const class_paused = ref(props.class_paused);

    const jitsi_api = ref(null);

    const time_random_biometric = ref(props.time_to_random_biometric);
	const mock_student_photo = usePage().props?.mock_user_photo as boolean;

	const starting_class = ref(false);
	const close_class = ref(false);
	const time_is_over_class = ref(false);
	const class_finished = ref(false);
	const random_biometry = ref(false);
	const failed_to_open_class = ref(false);

	const show_attachments = ref(false);

    const global_now:Ref<Date> = ref(new Date);

	const text_cam = ref({
		title: '',
		text_body: [
			'Certifique-se que somente você apareça na foto.',
			'Mantenha a <u style="color: #022D62">CABEÇA RETA</u> e o <u style="color: #022D62">OLHAR FIXO</u> para a câmera.',
			'Retire qualquer acessório que oculte <u style = "color: #022D62"> PARCIAL </u> ou <u style="color: #022D62">TOTALMENTE</u> seu <u style = "color: #022D62"> ROSTO</u>.',
			'Realize a captura clicando em <u style="color: #022D62">CAPTURAR FOTO</u>',
			'De acordo com a normativa do Detran, o sistema mantém sua webcam ligada e pode tirar fotos durante a aula.',
            `Você tem <u style="color: #022D62">${props.biometry_tries?.allowed_biometry_tries} tentativas</u> para realizar a biometria, preste atenção e siga os passos com cuidado.`
		],
	});

	const urlRoute = ref('');

    const student_biometry_tries = ref(props.biometry_tries.tries);

	const user_registrant_const: UserRegistrantConst = {
		registered_const_value: props.registered_const_value,
		initial_biometry_const_value: props.initial_biometry_const_value,
		random_biometry_const_value: props.random_biometry_const_value,
		finished_const_value: props.finished_const_value,
		failed_to_open_class_const_value:
			props.failed_to_open_class_const_value,
	};

	const times: Ref<TimesStudentClass> = ref({
		now: 0,
		class_deadline_with_additional_time: {
			distance: 0,
			minutes: 0,
			seconds: 0,
		},
		class_deadline_miliseconds: 0,
		class_deadline_with_additional_time_miliseconds: 0,
		class_deadline: { distance: 0, minutes: 0, seconds: 0 },
		time_random_photo: { distance: 0, minutes: 0, seconds: 0 },
		student_time_limit_to_open_class: 0,
	});

	const user_registrant_status = computed(
		() => props.records.status
	);

	const student_in_class = computed(() => {
		return props.student_in_class_consts.includes(
			user_registrant_status.value
		) && !props.ban;
	});

	const last_seen_setInterval_id = ref(0) as Ref<NodeJS.Timeout | number>;

	const user_cam_component = ref<InstanceType<typeof user_cam_modal> | null>(
		null
	);

    const meeting_iframe_key = ref(0);

    const browser_has_camera_permission = ref(false);

    const browser_permission_unknown_error = reactive({
        error_message: '',
        active: false,
    });

    const user_cam_modal_key = ref(1)

    let media_permission_modal: any = null;

    let check_ban_status: NodeJS.Timeout | null = null;

	watch(
		student_in_class,
		(newValue) => {
			if (newValue && props.haveMeet) {
				timerSaveStudentLastSeen();
			} else if (!newValue && last_seen_setInterval_id.value !== 0) {
				clearInterval(last_seen_setInterval_id.value);
			}
		},
		{ immediate: true }
	);

	watch(starting_class, async (newValue, oldValue) => {
		if (newValue && props.records.class_status === 'STARTED') {
            handleStudentBiometry(props.store_student_photo_urls.store_open_photo_url);
            text_cam.value.title = 'ABERTURA DE AULA no DETRAN';
            user_cam_component.value?.openModal();
			menuStore().addStudentStartingClassBiometryOption();
		}
	});

	watch(close_class, async (newValue, oldValue) => {
		if (newValue) {
            handleStudentBiometry(props.store_student_photo_urls.store_finish_photo_url)
			text_cam.value.title = 'FECHAMENTO DE AULA no DETRAN';
            user_cam_component.value?.openModal();
            menuStore().addStudentCloseClassBiometryOption();
		}
	});

	watch(time_is_over_class, async (newValue, oldValue) => {
		if (newValue) {
			user_cam_component.value?.closeModal();
			menuStore().resetStudentSpecialOptions();
		}
	});

	watch(random_biometry, async (newValue, oldValue) => {
		if (newValue) {
            if (  
                !class_paused.value &&
                (times.value.class_deadline.distance >
                props.milliseconds_between_random_biometrics)
            ) {
                time_random_biometric.value = new Date(
                    global_now.value.getTime() +
                    props.milliseconds_between_random_biometrics
                );

                random_biometry.value = false;

                if (browser_has_camera_permission.value) {
                    new SnapPhotoAndSendRequestSavePhoto(
                        props.random_photo_url,
                        props.mock_user_photo_b64
                    );
                }
                else {
                    media_permission_modal.show()
                }
            }
        }
	})

	watch(failed_to_open_class, async (newValue, oldValue) => {
		if (newValue) {
			user_cam_component.value?.closeModal();
			menuStore().resetStudentSpecialOptions();
		}
	});

    function handleSuccessfulBiometry() {
        partialReload(() => {
            student_biometry_tries.value = props.biometry_tries.tries
        })
    }

    async function handleBrowserPermissions() {
        let browser_has_permission = await BrowserMediaPermissionManager.browserHasCameraPermission()

        if(browser_has_permission) {
            browser_has_camera_permission.value = browser_has_permission
            return ;
        }

        try {
            await BrowserMediaPermissionManager.requestBrowserMediaPermissions();
        } catch (error) {
            //@ts-ignore
            if (error.name === 'NotAllowedError') {
                browser_has_camera_permission.value = false;
            } else {
                browser_permission_unknown_error.active = true;
                browser_permission_unknown_error.error_message = error as string;
            }
        }

        browser_has_camera_permission.value = await BrowserMediaPermissionManager.browserHasCameraPermission()
    }

	function resetButtonsRefs() {
		starting_class.value = false;
		close_class.value = false;
		time_is_over_class.value = false;
		class_finished.value = false;
	}

	function handleStudentBiometry(biometry_option_route: string) {
		if (document.fullscreenElement) {
			document.exitFullscreen();
		}
		urlRoute.value = biometry_option_route;
	}

	function timerChangePage(
		class_deadline,
		class_deadline_with_additional_time,
		time_middle_class_biometric_validation,
		student_time_limit_to_open_class,
		now: Date
	) {
		const interval_id = setInterval(() => {
			var deadline = new Date(class_deadline);

			now.setSeconds(now.getSeconds() + 1);

            menuStore().setDateTime(now.toLocaleString())

			times.value.now = now.getTime();

			times.value.class_deadline_with_additional_time =
				getTimerWithDistanceMinutesSeconds(
					class_deadline_with_additional_time,
					times.value.now
				);

			times.value.time_random_photo = getTimerWithDistanceMinutesSeconds(
				time_random_biometric.value,
				times.value.now
			);

			times.value.class_deadline_miliseconds = new Date(
				class_deadline
			).getTime();

			times.value.class_deadline_with_additional_time_miliseconds =
				new Date(class_deadline_with_additional_time).getTime();

			times.value.class_deadline = getTimerWithDistanceMinutesSeconds(
				deadline,
				times.value.now
			);

			times.value.student_time_limit_to_open_class = new Date(
				student_time_limit_to_open_class
			).getTime();

			changeActionPage(
				user_registrant_const,
				props.records.status,
				times.value,
				interval_id
			);
		}, 1000);

		return interval_id;
	}

	function changeActionPage(
		user_registrant_const: UserRegistrantConst,
		student_status: string,
		times: TimesStudentClass,
		loop
	) {
		if (props.records.class_status === 'CANCELED') {
			clearInterval(loop);
			Swal.fire({
				title: 'Aula cancelada pelo instrutor',
				icon: 'warning',
				text: 'Entre em contato com o instrutor/CFC para saber mais informações',
				showConfirmButton: false,
				timer: 10000,
				timerProgressBar: true,
			}).then(() => {
				window.location.href = `/dashboard/lista-aulas/${props.records.enroll_id}`;
			});
		}
		if (props.records.class_status === 'PENDING') {
			clearInterval(loop);
			Swal.fire({
				title: 'Aula foi fechada com pendencia',
				icon: 'warning',
				text: 'Entre em contato com o instrutor/CFC para saber mais informações',
				showConfirmButton: false,
				timer: 10000,
				timerProgressBar: true,
			}).then(() => {
				window.location.href = `/dashboard/lista-aulas/${props.records.enroll_id}`;
			});
		}

		const student_failed_to_open_class =
			student_status ===
				user_registrant_const.failed_to_open_class_const_value ||
			(times.now > times.student_time_limit_to_open_class &&
				student_status ===
					user_registrant_const.registered_const_value);

		const student_should_do_random_biometry =
			times.time_random_photo.distance <= 0 && student_in_class.value;

		const student_can_start_class =
			student_status === user_registrant_const.registered_const_value &&
			times.class_deadline.distance >= 0;

		const class_in_additional_time = times.class_deadline.distance <= 0;

		const student_finished_class_sucessfully =
			student_status === user_registrant_const.finished_const_value;

		const time_is_over =
			times.now > times.class_deadline_with_additional_time_miliseconds ||
			props.records.closed_before_students_waiting_time !== null;

		if (student_failed_to_open_class) {
			clearInterval(loop);
			resetButtonsRefs();
			failed_to_open_class.value = true;
			return;
		}

        if(class_paused.value || props.ban) {
            return;
        }

		if (student_should_do_random_biometry) {
			random_biometry.value = true;
		}

		if (student_can_start_class) {
			resetButtonsRefs();
			starting_class.value = true;
			return;
		}

		if (student_finished_class_sucessfully) {
			clearInterval(loop);
			resetButtonsRefs();
			class_finished.value = true;
            menuStore().setDateTime(null)
			return;
		} else {
			if (time_is_over) {
				clearInterval(loop);
				resetButtonsRefs();
				time_is_over_class.value = true;
                menuStore().setDateTime(null)
				return;
			}

			if (class_in_additional_time) {
				if (
					props.invalid_statuses_for_student_operations.includes(
						student_status
					)
				) {
					clearInterval(loop);
					resetButtonsRefs();
					time_is_over_class.value = true;
                    menuStore().setDateTime(null)
					return;
				}

				resetButtonsRefs();
				close_class.value = true;
				return;
			}
		}
	}
	function partialReload(onSuccessCallback: any = undefined) {
		router.reload({
			only: [
				'records',
				'haveMeet',
				'student_registered_in_class',
				'class_finished',
				'class_deadline',
				'class_deadline_with_additional_time',
				'time_middle_class_biometric_validation',
				'student_last_seen',
                'biometry_tries',
                'ban'
			],
            onSuccess: onSuccessCallback
		});

		menuStore().resetStudentSpecialOptions();
	}

	function saveStudentLastSeen() {
		axios.post(
			props.student_last_seen_route,
			{
				class_id: props.records.class_id,
			},
			{
				headers: { Authorization: props.api_token },
			}
		).catch(function (error) {
			console.log(error);
		});
	}

	function timerSaveStudentLastSeen() {
		const last_seen_miliseconds =
			new Date(props.student_last_seen).getTime() +
			props.miliseconds_to_check_student_activity;
		const activity_check = last_seen_miliseconds - Date.now();
		setTimeout(
			() => {
				saveStudentLastSeen();
				last_seen_setInterval_id.value = setInterval(
					saveStudentLastSeen,
					props.miliseconds_to_check_student_activity
				);
			},
			activity_check > 0 ? activity_check : 0
		);
	}

	function handleActivity() {
        global_now.value = new Date(props.now)

		let timer_change_page = timerChangePage(
			props.class_deadline,
			props.class_deadline_with_additional_time,
			props.time_middle_class_biometric_validation,
			props.student_time_limit_to_open_class,
			global_now.value
		);

		document.addEventListener('visibilitychange', async function () {
			if (document.hidden) {
				clearInterval(timer_change_page);

                menuStore().setDateTime(null)
			} else {
                const start_request_timestamp = new Date().getTime();

                const { server_timestamp, server_client_request_diff_time } = await axios.get(props.get_time_url, {
                    params: {
                        "client_timestamp": start_request_timestamp
                    }
                }).then(response => response.data);

                const now_timestamp = new Date().getTime();

                const server_client_response_diff_time = now_timestamp - server_timestamp;

                const response_time = (server_client_request_diff_time - now_timestamp + start_request_timestamp - server_client_response_diff_time) / 2;

                global_now.value = new Date(now_timestamp + (server_client_response_diff_time - response_time));

				timer_change_page = timerChangePage(
					props.class_deadline,
					props.class_deadline_with_additional_time,
					props.time_middle_class_biometric_validation,
					props.student_time_limit_to_open_class,
					global_now.value
				);
			}
		});
	}

    async function classPausedFunction(jitsi_api: Ref<any>) {
        class_paused.value = true

        const mic_muted = await jitsi_api.value?.isAudioMuted()

        const video_muted = await jitsi_api.value?.isVideoMuted()

        if(!mic_muted) jitsi_api.value?.executeCommand('toggleAudio');

        if(!video_muted) jitsi_api.value?.executeCommand('toggleVideo');
    }

    let last_ban_check_timestamp = 0;
    let ban_check_timeout: NodeJS.Timeout | null = null;
    let is_checking_ban_status = false;
    
    async function updateStatus() {        
        if (is_checking_ban_status) {
            return;
        }
                
        const now = Date.now();
        if (now - last_ban_check_timestamp < 30000) { 
            return;
        }
        
        is_checking_ban_status = true;
        last_ban_check_timestamp = now;
        
        try {
            const response = await axios.get(props.get_ban_status_url, {
                params: {
                    class_id: props.records.class_id,
                    user_id: props.records.user_id
                },
                timeout: 5000
            });

            if (response.data.banned && !props.ban) {                
                partialReload();
                (window as any).toastr.error('Você foi banido desta aula!');                
                if (check_ban_status) {
                    clearInterval(check_ban_status);
                    check_ban_status = null;
                }
            } else if (!response.data.banned && props.ban) {                
                partialReload();
                (window as any).toastr.success('Seu banimento foi removido!');
            }
        } catch (error) {
            console.error('Erro ao verificar status de banimento:', error);            
            scheduleDelayedBanCheck(60000);
        } finally {
            is_checking_ban_status = false;
        }
    }
    
    function scheduleDelayedBanCheck(delay: number) {
        if (ban_check_timeout) {
            clearTimeout(ban_check_timeout);
        }
        ban_check_timeout = setTimeout(() => {
            updateStatus();
        }, delay);
    }

    function startUpdateStatusInterval() {                
        updateStatus();            
        check_ban_status = setInterval(updateStatus, 300000);
    }    

	onMounted(async () => {
        media_permission_modal = new (window as any).bootstrap.Modal('#mediaPermissionModal');

        await handleBrowserPermissions()

        user_cam_modal_key.value = user_cam_modal_key.value + 1

        if(!browser_has_camera_permission.value) {
            media_permission_modal.show();
        }
        else {
            media_permission_modal.hide();
        }

        handleActivity();

		const student_ws = new WebSocketStudentBuilder()
			.setWsScheme(props.ws_scheme)
			.setWsBaseUrl(props.ws_base_url)
			.setClassId(props.records.class_id)
			.setClientId((Math.random() + 1).toString(36).substring(3))
			.setUserId(props.records.user_id)
			.setMockStudentPhoto(mock_student_photo)
			.setMockStudentPhotoUrl(props.mock_user_photo_b64)
			.setRandomPhotoUrl(props.random_photo_url)
            .setStudentBannedFunction(() => {
                partialReload()
                if (close_class.value) {
                    user_cam_component.value?.closeModal();
                }
            })
            .setStudentUnbannedFunction(() => {
                partialReload()
                if (close_class.value) {
                    user_cam_component.value?.openModal();
                }
            })
			.makeStudentWebSocketUrl()
			.build();

		const general_ws = new WebSocketStudentBuilder()
			.setWsScheme(props.ws_scheme)
			.setWsBaseUrl(props.ws_base_url)
			.setClassId(props.records.class_id)
			.setClientId((Math.random() + 1).toString(36).substring(3))
			.setMockStudentPhoto(mock_student_photo)
			.setMockStudentPhotoUrl(props.mock_user_photo_b64)
			.setUserRegistrantStatus(props.records.status)
			.setRandomPhotoUrl(props.random_photo_url)
            .setClassPausedFunction(async () => await classPausedFunction(jitsi_api))
            .setFinishedClassPauseFunction(() => class_paused.value = false)
			.makeGeneralWebSocket()
			.build();

		student_ws.connectWs();
		general_ws.connectWs();
        
        if (props.records.class_status === 'STARTED' && !props.ban) {
            // startUpdateStatusInterval();
        }

		if (props.records.class_status === 'READY') {
			var initial_status = setInterval(() => {
				if (props.records.class_status !== 'READY') {
					clearInterval(initial_status);
				}
				window.location.reload();
			}, 10000);
		}

        const can_load_jitsi = props.records.class_status === 'READY' || props.records.class_status === 'STARTED';

        if(!props.jitsi_domain && can_load_jitsi) {
            const refresh_jitsi_domain = setInterval(()=> {
                if(props.jitsi_domain) {
                    clearInterval(refresh_jitsi_domain);
                    return ;
                }

                router.reload({
                    only: ['jitsi_domain'],
                    onFinish: () => meeting_iframe_key.value += 1
                })
            }, 20000);
        }

        if(!jitsi_api.value) {
            const reload_iframe_component_timer = setInterval(() => {

                if(jitsi_api.value) {
                    clearInterval(reload_iframe_component_timer);
                    return;
                }

                meeting_iframe_key.value += 1
            }, 5000)
        }

        const seen_warning_time = parseInt(localStorage.getItem('seen_pending_items_warning_at') ?? '0');

        const now = new Date(props.now);

        const warning_expired = now.getTime() > seen_warning_time;

        if (props.has_pending_items && warning_expired) {
            await Swal.fire({
                title: 'Você possui pendências',
                icon: 'warning',
                text: 'Você possui pendências no DETRAN, entre em contato com a sua CFC para saber mais informações',
                showConfirmButton: true,
                confirmButtonText: 'Entendi',
                timerProgressBar: true,
                allowOutsideClick: true,
            })

            now.setHours(now.getHours() + 5);

            const expire_milliseconds = now.getTime();

            localStorage.setItem('seen_pending_items_warning_at', expire_milliseconds.toString());
        }
    });


	onBeforeMount(() => {
		//activate 'aula online' option on side menu
		menuStore().isMeetingPage();
	});
		
	onUnmounted(() => {
		if (check_ban_status) {
			clearInterval(check_ban_status);
			check_ban_status = null;
		}
		if (ban_check_timeout) {
			clearTimeout(ban_check_timeout);
			ban_check_timeout = null;
		}
		if (last_seen_setInterval_id.value !== 0) {
			clearInterval(last_seen_setInterval_id.value);
		}
	});
</script>
